// extracted by mini-css-extract-plugin
export default {"bigTitleLine":"index_bigTitleLine_SbRVg","columnTitle":"index_columnTitle_UpH2Q","more":"index_more_-enYq"};